/*
 *
 * Trackerbase login view controller.
 * Angular module: trackerbase-app.views.tb-login-view
 * Controller name: tbLoginViewCtrl
 * Exposed as: tbLoginView
 *
 */
import angular from "angular";

import uiRouter from "@uirouter/angularjs";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TbLoginViewModuleConstants from "./Constants";

import TbLoginViewController from "./TbLoginViewController";

function ConfigureTbLoginView($stateProvider) {

    $stateProvider.state(TbLoginViewModuleConstants.rootStateName, {
        url: "/tb-login?reason&message",
        template: TbLoginViewController.template,
        controller: TbLoginViewController,
        controllerAs: TbLoginViewController.controllerAs
    });
}

ConfigureTbLoginView.$inject = [ "$stateProvider" ];

const tbLoginViewModuleDependencies = DependencyListBuilder([
    TbLoginViewController.dependencies,
    [
        uiRouter
    ]
]);

export default angular
    .module(
        "trackerbase-app.views.tb-login-view",
        tbLoginViewModuleDependencies
    )
    .config(ConfigureTbLoginView)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tb-login-view/TbLoginView.js
// module id = 6H+S
// module chunks = 1